import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaTelegramPlane,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import ContactCard from "./ContactCard";
import { AiOutlineSkype } from "react-icons/ai";
import { Box, Typography } from "@mui/material";

const ContactData = ({ data }) => {
  const renderInfoSection = () => {
    return data?.smmpanel_email ||
      data?.smmpanel_whatsapp ||
      data?.smmpanel_telegram ||
      data?.smmpanel_tel1 ||
      data?.smmpanel_fb ||
      data?.smmpanel_instagram ||
      data?.smmpanel_skype ||
      data?.smmpanel_twitter
      ? true
      : false;
  };

  return (
    renderInfoSection() && (
      <Box className="contact-info px-[30px] border-y-[1px] border-secondary dark:border-darkSecondary py-4">
        <Typography className="title">Contact info</Typography>
        <div container className="data">
          {data?.smmpanel_email && (
            <ContactCard
              icon={<MdOutlineEmail size={"1.2rem"} />}
              link={`mailto:${data.smmpanel_email}`}
              title={data.smmpanel_email}
            />
          )}
          {data?.smmpanel_whatsapp && (
            <ContactCard
              icon={<FaWhatsapp size={"1.2rem"} />}
              link={`https://wa.me/${data.smmpanel_whatsapp}`}
              title={data.smmpanel_whatsapp}

            />
          )}
          {data?.smmpanel_telegram && (
            <ContactCard
              icon={<FaTelegramPlane size={"1.2rem"} />}
              title={data.smmpanel_telegram}
              link={`https://t.me/${data.smmpanel_telegram}`}
            />
          )}
          {data?.smmpanel_tel1 && (
            <ContactCard
              icon={<FaPhoneAlt size={"1.2rem"} />}
              title={data.smmpanel_tel1}
              link={`tel:${data.smmpanel_tel1}`}
            />
          )}
          {data?.smmpanel_fb && (
            <ContactCard
              icon={<FaFacebookF size={"1.2rem"} />}
              title={data.smmpanel_fb}
              link={data.smmpanel_fb}
            />
          )}
          {data?.smmpanel_instagram && (
            <ContactCard
              icon={<FaInstagram size={"1.2rem"} />}
              title={data.smmpanel_instagram}
              link={data.smmpanel_instagram}
            />
          )}
          {data?.smmpanel_skype && (
            <ContactCard
              icon={<AiOutlineSkype size={"1.2rem"} />}
              title={data.smmpanel_skype}
              link={`skype:${data.smmpanel_skype}?chat`}
            />
          )}
          {data?.smmpanel_twitter && (
            <ContactCard
              icon={<FaTwitter size={"1.2rem"} />}
              title={data.smmpanel_twitter}
              link={data.smmpanel_twitter}
            />
          )}
        </div>
      </Box>
    )
  );
};

export default ContactData;
